module.exports = __webpack_public_path__ + "img/sofia-spedaletti-byn.0aed6066.png";